'use client';

import React, { useEffect, useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { getTranslations } from '@/lib/i18n';

export default function FrLandingHero() {
  const [loaded, setLoaded] = useState(false);
  const t = getTranslations('fr');

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative h-screen min-h-[600px] flex items-end overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <AppImage
          src="/assets/images/IMG_7243-1775943727866.jpg"
          alt="Château de Dartmouth surplombant l'estuaire de la rivière Dart, Devon"
          fill
          priority
          className="object-cover animate-slow-zoom"
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-navy/20 via-deep-navy/30 to-deep-navy/80" />
      </div>
      <div
        className={`relative z-10 w-full px-8 md:px-16 xl:px-24 pb-20 md:pb-28 transition-all duration-[1200ms] ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-xs tracking-[0.4em] uppercase font-sans font-300 text-warm-sand mb-6">
          {t?.landing?.dateLine}
        </p>
      </div>
      <div className="absolute bottom-8 right-8 md:right-16 flex flex-col items-center gap-2 opacity-40">
        <div className="h-12 w-px bg-off-white" />
        <span className="text-xs tracking-[0.2em] uppercase font-sans text-off-white rotate-90 origin-center translate-y-6">
          {t?.landing?.scroll}
        </span>
      </div>
    </section>
  );
}
